import { IPFontIcon, IPTooltipHost } from 'baseComponents';
import { copyIcon, validIcon } from 'globalStyles';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ICopyIdProps {
  id: string | number;
}

const CopyId = (props: ICopyIdProps) => {
  const { t } = useTranslation('translation');
  const [copied, setCopied] = React.useState<boolean>(false);
  const [timer, setTimer] = React.useState<NodeJS.Timeout | undefined>(undefined);

  React.useEffect(() => {
    return () => {
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copyId = () => {
    navigator.clipboard.writeText(props.id.toString());
    setCopied(true);
    setTimer(setTimeout(() => setCopied(false), 2000));
  };

  return (
    <IPTooltipHost
      content={t('translation:CopyId.Tooltip', { id: props.id })}
      styles={{
        root: {
          selectors: {
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
      }}
    >
      {!copied && <IPFontIcon {...copyIcon} onClick={copyId}></IPFontIcon>}
      {copied && <IPFontIcon {...validIcon}></IPFontIcon>}
    </IPTooltipHost>
  );
};

export default CopyId;
